import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { addTransaction } from '../api/transaction_api';
import TransactionForm from './TransactionForm';

const AddTransaction = () => {
    const { beneficiary_id } = useParams();
    const location = useLocation();
    const { beneficiaryName } = location.state || {};
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const category = e.target.category.value;
        const welfareSubcategory = e.target.welfare_subcategory?.value || null;
        const meetingDates = Array.from(e.target.querySelectorAll('input[name="meeting_dates"]'))
            .map((input) => input.value)
            .filter(Boolean);
        const meetingCount = meetingDates.length || null;

        if (category === 'סיוע ורווחה' && welfareSubcategory === 'טיפול ע"י מטפל') {
            if (!meetingCount) {
                alert('יש למלא לפחות תאריך מפגש אחד עבור טיפול ע"י מטפל');
                return;
            }
        }

        const transaction = {
            beneficiary_id: beneficiary_id,
            provider_name: e.target.provider_name.value,
            payment_to_supplier: e.target.payment_to_supplier?.value || null,
            payment_method: e.target.payment_method.value,
            category,
            welfare_subcategory: welfareSubcategory,
            meeting_count: meetingCount,
            meeting_dates: meetingDates,
            amount: e.target.amount.value,
            date: e.target.date.value,
            comments: e.target.comments.value,
            check_date: e.target.check_date?.value || null,
            check_number: e.target.check_number?.value || null,
            check_amount: e.target.check_amount?.value || null,
        };
        try {
            await addTransaction(transaction);
            alert('הפעולה נוספה בהצלחה');
            navigate(`/beneficiaries/${beneficiary_id}`);
        } catch (err) {
            console.log(err);
            alert('הוספת הפעולה נכשלה');
        }
    };

    return (
        <>
            <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <div dir="rtl" style={{ maxWidth: '500px', margin: 'auto' }}>
                <h2 style={{ color: "#150F6B", marginRight: "12%" }}>הוספת פעולה ל{beneficiaryName}</h2>
                <TransactionForm onSubmit={handleSubmit} mode="add" />
            </div>
        </>
    );
};

export default AddTransaction;
